/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationUrlDTO
 */
export interface ApplicationUrlDTO {
    /**
     * 
     * @type {string}
     * @memberof ApplicationUrlDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationUrlDTO
     */
    url?: string;
}

export function ApplicationUrlDTOFromJSON(json: any): ApplicationUrlDTO {
    return ApplicationUrlDTOFromJSONTyped(json, false);
}

export function ApplicationUrlDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationUrlDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function ApplicationUrlDTOToJSON(value?: ApplicationUrlDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'url': value.url,
    };
}

